<template>
  <div class="__UsageSideListItem" :class="{ active: active }" @click="handleClick">
    <div class="__UsageSideListItem_Badges">
      <template v-for="(item, index) in badges">
        <CTooltip :message="$t(item.message)" position="top close" :delay="50" :key="index">
          <CBadge :color="item.type">
            <template v-if="item.icon">
              <CIcon name="notifications_active" material />
            </template>

            <template v-else>
              {{ item.value }}
            </template>
          </CBadge>
        </CTooltip>
      </template>
    </div>

    <div class="__UsageSideListItem_Body">
      <slot v-if="$slots.default" />

      <template v-else>
        <div class="__UsageSideListItem_Body_Title">{{ title }}</div>
        <div class="__UsageSideListItem_Body_Description">{{ description }}</div>
      </template>
    </div>
  </div>
</template>

<script>
import Badge from '@/components/uikit/Badge';
import CBadge from '@/components/uikit/CBadge';
import CTooltip from '@/components/uikit/CTooltip';
import CIcon from '@/components/uikit/CIcon';

const messages = {
  en: {
    'Payer account': 'Payer account',
    'Notification enabled': 'Notification enabled',
  },
  ja: {
    'Payer account': '支払いアカウント',
    'Notification enabled': '通知設定済み',
  },
};

export default {
  name: 'ListItem',
  i18n: { messages },
  components: { Badge, CBadge, CTooltip, CIcon },
  props: {
    title: String,
    description: String,
    badges: Array,
    active: Boolean,
  },
  methods: {
    handleClick() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss" scoped>
.__UsageSideListItem {
  position: relative;
  background-color: $foundation-color;
  margin: 0.8rem 0;
  border-radius: 6px;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba($neutral-color, 0.12);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 5px 12px rgba($neutral-color, 0.2), 0 0 0 2px $primary-color;

    .__UsageSideListItem_Body_Title {
      color: $primary-color;
    }
  }

  &.active {
    box-shadow: 0 5px 12px rgba($neutral-color, 0.2), 0 0 0 2px $primary-color;

    .__UsageSideListItem_Body_Title {
      color: $primary-color;
    }
  }

  &_Badges {
    position: absolute;
    top: -10px;
    left: 10px;
    display: flex;
    align-items: center;
    text-transform: uppercase;

    & > div {
      margin-right: $space-xs;
    }
  }

  &_Body {
    padding: $space-md;

    &_Title {
      margin-bottom: $space-xs;
      font-weight: 500;
      line-height: 1.1;
      word-break: break-all;
    }

    &_Description {
      color: $neutral-secondary-color;
      font-size: $font-size-sm;
    }
  }
}
</style>
